moment.locale('de');

var ruDate = {
    previousMonth: 'vorheriger Monat',
    nextMonth: 'nächsten Monat',
    months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
    weekdays: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
    weekdaysShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa']
};

$(function () {
    $('.pikaday, .second, .pikaday-concrete').each(function (index, element) {
        let minDate = element.getAttribute('data-min-date');
        let maxDate = element.getAttribute('data-max-date');

        let pikaday = new Pikaday({
            field: element,
            i18n: ruDate,
            firstDay: 1,
            format: 'DD.MM.YYYY',
            onSelect: function () {
                $(element).trigger('input', {value: element.value});
            }
        });

        if(minDate) {
            pikaday.setMinDate(new Date(minDate));
        }

        if(maxDate) {
            pikaday.setMaxDate(new Date(maxDate));
        }
    })

    $('.first').each((index, element) => {
        new Pikaday({
            field: element,
            i18n: ruDate,
            firstDay: 1,
            format: 'DD.MM.YYYY',
            onSelect: function(date){
                let selectedDate = new Date(date);
                let endDate = new Date(selectedDate.getTime());
                $('.second').each((index, element) => {
                    new Pikaday({
                        field: element,
                        i18n: ruDate,
                        firstDay: 1,
                        minDate: endDate,
                        format: 'DD.MM.YYYY',
                    })
                })
            }
        })
    })

    $('.pikaday-monthly').each((index, element) => {
        new Pikaday({
            field: element,
            i18n: ruDate,
            firstDay: 1,
            format: 'MM.YYYY',
            onSelect: function () {
                Livewire.dispatch("selectedDateChangedEvent", {
                    date: this.getMoment().format('MM.YYYY')
                });
            }
        })
    })
});
